export const tagType = {
  pageView: 'pageview',
  event: 'event',
};

export const tracking = (
  tagType,
  documentTitle,
  eventCategory,
  eventAction,
  eventLabel,
) => {
  const obj = {
    section: 'VisualizationServerless',
    type: tagType,
    documentTitle,
    documentUrl: window.location.href,
  };

  if (eventCategory) {
    obj.primaryCategory = eventCategory;
  }

  if (eventAction) {
    obj.eventAction = eventAction;
  }

  if (eventLabel) {
    obj.eventName = eventLabel;
  }

  if (window.ibmStats && window.ibmStats.event) {
    window.ibmStats.event(obj);
  } else {
    console.log(obj);
  }
};
